export function decodeSpidFromGraphqlIdResponse(graphqlIdResponse?: string | undefined | null | number) {
  if (!graphqlIdResponse) {
    return undefined
  }
  return `${graphqlIdResponse}`.split('/').pop()
}
